import { titleCase } from "@memorang/helpers/common";
import Box from "../Box";
import SavedArticleListItem from "./SavedArticleListItem";

export type Article = {
	id: number;
	content: string;
	title: string;
	imageUri: string;
	type: string;
	rsuiteId: string;
	subSpecialties: string[];
	showOnlyAbstract?: boolean;
};

type Props = {
	savedArticles: Article[];
	handleSelectArticle: (id: number) => void;
	selectedArticleIds: number[];
	handleNavigateToArticle: (id: number) => void;
};

export const SavedArticlesList = ({
	savedArticles,
	handleSelectArticle,
	selectedArticleIds,
	handleNavigateToArticle,
}: Props) => {
	return (
		<Box>
			{savedArticles.map((item) => {
				const status = selectedArticleIds.includes(item.id)
					? "checked"
					: "unchecked";
				return (
					<SavedArticleListItem
						key={item.title}
						{...item}
						description={titleCase(item.type)}
						status={status}
						onCheck={() => handleSelectArticle(item.id)}
						onPress={() => handleNavigateToArticle(item.id)}
					/>
				);
			})}
		</Box>
	);
};
